import React from 'react';

const DashedLine = () => {
  return (
    <div className="dashed-line-container">
      ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    </div>
  );
};

export default DashedLine;
